<template>
  <section class="split row">
    <div class="row__item -span-6 split__content">
      <ContentTitle v-if="title" align-left flat>{{ title }}</ContentTitle>
      <slot />
    </div>

    <figure class="row__item -span-6 split__image" :style="{ backgroundImage }" />
  </section>
</template>

<script>
import ContentTitle from './ContentTitle.vue'

export default {
  name: 'ContentSection',
  components: { ContentTitle },
  props: {
    image: { type: String, required: true },
    title: { type: String, default: null }
  },
  computed: {
    backgroundImage() {
      return `url(${this.image})`
    }
  }
}
</script>
